import mitt from 'mitt';

const bus = mitt();

export default defineNuxtPlugin(() => {
    return {
        provide: {
            bus,
        },
    };
});
